import { Injectable } from "@angular/core";

@Injectable()
export class FileUploadConstants {

  public BADGE_DOCUMENTS_API_PATH: string = "/view/rms/ResponderBadgeDocument/";
  public DOWNLOAD_DOCUMENTS_API_PATH: string = "/view/rms/ResponderDocument/";
  public BADGE_DOCUMENTS_FOLDER: string = "BadgeDocuments";
  public BADGE_DOCUMENTS_FILE_TYPES: number[] = [19];
  public IMMUNIZATION_DOCUMENTS_FOLDER: string = "ImmunizationDocuments";
  public IMMUNIZATION_DOCUMENTS_FILE_TYPES: number[] = [15];
  public IMMUNIZATION_DOCUMENTS_API_PATH: string = "/view/rms/ResponderImmunizationDocument/";
  public LICENSE_DOCUMENTS_FOLDER: string = "LicenseDocuments";
  public LICENSE_DOCUMENTS_FILE_TYPES: number[] = [2];
  public LICENSE_DOCUMENTS_API_PATH: string = "/view/rms/ResponderLicenseDocument/";
  public NOTIFICATION_ATTACHMENTS_API_PATH: string = "/view/rms/NotificationAttachment/";
  public ROSTER_DOCUMENT_TYPES: number[]=[32];
  public RESPONDER_DOCUMENTS_FOLDER: string = "ResponderDocuments";
  public RESPONDER_DOCUMENTS_EXCLUDE_FILE_TYPES: number[] = [14, 15, 28, 29, 30, 31, 32, 33, 34];
  public RESPONDER_DOCUMENTS_EXCLUDE_SELF_SERVICE: number[] = [1, 3, 6, 14, 15, 28, 29, 30, 31, 32, 33, 34]
  public RESPONDER_DOCUMENTS_API_PATH: string = "/view/rms/ResponderDocument/";
  public ROSTER_DOCUMENTS_API_PATH: string = "/view/rms/RosterDocument/";
  public ROSTER_DOCUMENTS_ARCHIVE_API_PATH: string = "/view/rms/RosterDocumentArchive/";
}
